import { useQuery } from 'react-query';
import CompanyService from 'App/services/CompanyService';

function useFetchCompanyBranchesQuery(isActive = false) {
    return useQuery(['company', 'branches', isActive ? 'active' : 'all'], {
        queryFn: () => CompanyService.getCompanyBranches(isActive),
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchCompanyBranchesQuery;
